import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SupplierDetails } from '../models/SupplierDetails';
import { Supplier } from '../models/Supplier';
import { Invitation } from '../../../shared/components/invitation-options-component/invitation';
import { RequestStatusContractFui } from '../../account/models/RequestStatusContractFui';
import { Page } from 'src/app/shared/model/page';
import { NotificationFilterForm } from '../../anre/notifications-anre/models/NotificationFilterForm';
import { Filter } from '../../../shared/model/filter';
import { UtilService } from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {

  private supplierUrl = '/furnizor';

  constructor(
    private http: HttpClient,
    private utils: UtilService
  ) { }

  getSupplierDetails(): Observable<SupplierDetails> {
    return this.http.get<SupplierDetails>(environment.baseUrl + this.supplierUrl + '/detalii-furnizor');
  }

  getSupplierDetailsById(id: string): Observable<SupplierDetails> {
    return this.http.get<SupplierDetails>(environment.baseUrl + this.supplierUrl + '/detalii-furnizor/' + id);
  }

  getSupplierDetailsByLegalIDCode(code: string): Observable<SupplierDetails> {
    return this.http.get<SupplierDetails>(environment.baseUrl + this.supplierUrl + '/detalii-furnizor/legalIDCode/' + code);
  }

  updateSupplierDataDetails(supplierDetails: FormData): Observable<SupplierDetails> {
    return this.http.put<SupplierDetails>(environment.baseUrl + this.supplierUrl + '/detalii-furnizor', supplierDetails);
  }

  updateSupplierFuiDetails(supplier: Supplier): Observable<SupplierDetails> {
    return this.http.put<SupplierDetails>(environment.baseUrl + this.supplierUrl + '/status-update-fui', supplier);
  }

  updateUnvalidatedReasonFuiStatus(requestObject: any): Observable<SupplierDetails> {
    return this.http.put<SupplierDetails>(environment.baseUrl + this.supplierUrl + `/status-update-unvalidated-reason/${requestObject.code}&${requestObject.impossibilityReason}&${requestObject.startDate}`, {});
  }

  getSupplierTasks(): Observable<any[]> {
    return this.http.get<any[]>(environment.baseUrl + `/task/supplier`);
  }

  getSupplierNotifications(notificationFilterForm: NotificationFilterForm): Observable<Page<any>> {
    return this.http.post<Page<any>>(environment.baseUrl + this.supplierUrl + '/notifications', notificationFilterForm);
  }

  getSPElectricitySupplierContracts(filter: Filter): Observable<Page<any>> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(filter.pageOffset)) {
      params = params.append('page', filter.pageOffset);
    }
    if (this.utils.nonNullAndNonUndefined(filter.filter)) {
      params = params.append('filter', JSON.stringify(filter.filter));
    }
    return this.http.get<Page<any>>(environment.baseUrl + '/furnizor/lista-contracte-furnizare/electricity', { params });
  }

  getSPGasSupplierContracts(filter: Filter): Observable<Page<any>> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(filter.pageOffset)) {
      params = params.append('page', filter.pageOffset);
    }
    if (this.utils.nonNullAndNonUndefined(filter.filter)) {
      params = params.append('filter', JSON.stringify(filter.filter));
    }
    return this.http.get<Page<any>>(environment.baseUrl + '/furnizor/lista-contracte-furnizare/gas', { params });
  }

  getSPElectricityNetworkContracts(filter: Filter): Observable<Page<any>> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(filter.pageOffset)) {
      params = params.append('page', filter.pageOffset);
    }
    if (this.utils.nonNullAndNonUndefined(filter.filter)) {
      params = params.append('filter', JSON.stringify(filter.filter));
    }
    return this.http.get<Page<any>>(environment.baseUrl + '/supplier/lista-contracte/electricitate', { params });
  }

  getSPGasNetworkContracts(filter: Filter): Observable<Page<any>> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(filter.pageOffset)) {
      params = params.append('page', filter.pageOffset);
    }
    if (this.utils.nonNullAndNonUndefined(filter.filter)) {
      params = params.append('filter', JSON.stringify(filter.filter));
    }
    return this.http.get<Page<any>>(environment.baseUrl + '/supplier/lista-contracte/gaze', { params });
  }

  assignSupplierTask(taskId: number): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/task/${taskId}/assign`, {});
  }

  resolveAnreTask(taskId: number, task: any): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/task/${taskId}/resolve`, task);
  }

  cancelContract(contractId: number, requestStatusContractFui: RequestStatusContractFui): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/furnizor/incetare-contract/${contractId}`, requestStatusContractFui);
  }

  removeCancelContract(contractId: number): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/furnizor/anulare-incetare-contract/${contractId}`, {});
  }

  getInvitations(): Observable<Invitation[]> {
    return this.http.get<Invitation[]>(environment.baseUrl + '/invitatie/furnizor');
  }

  removeInvitation(invitationId: number): Observable<Invitation | null> {
    return this.http.delete<Invitation | null>(environment.baseUrl + `/invitatie/furnizor/${invitationId}`);
  }

  addInvitation(invitation: Invitation): Observable<Invitation> {
    return this.http.post<Invitation>(environment.baseUrl + '/invitatie/furnizor', invitation);
  }

  updateNotificationRead(notification: Notification): Observable<Notification> {
    return this.http.put<Notification>(environment.baseUrl + this.supplierUrl + '/notification-status-update', notification);
  }
}
